import React, { useState } from 'react';
import './TotalAmountModal.css';

const TotalAmountModal = ({ order, onSave, onClose }) => {
  const [total, setTotal] = useState(order.total || '');

  const handleSave = () => {
    if (!total || isNaN(total) || total <= 0) {
      alert('Por favor, ingresa un valor numérico válido para el total.');
      return;
    }
    onSave(order.id, Number(total));
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Registrar Total de la Orden</h3>
        <p>Cliente: <strong>{order.customer_name}</strong></p>
        
        <div className="form-group">
          <label htmlFor="totalAmount">Valor Total de la Cuenta ($)</label>
          <input
            type="number"
            id="totalAmount"
            value={total}
            onChange={(e) => setTotal(e.target.value)}
            placeholder="Ej: 250.50"
            autoFocus
          />
        </div>

        <div className="modal-actions">
          <button onClick={handleSave} className="save-btn">Guardar Total</button>
          <button onClick={onClose} className="cancel-btn">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default TotalAmountModal;